import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { ROUTE_GET_VAULT_DISCLOSURES } from "../constants";
import { parseVaultDisclosuresFromApi, VaultDisclosuresResponse, VaultDisclosuresResponseApi } from "../types";
import { abfSerializeQueryArgs, marketsPublicBaseQuery } from "./util";

const VAULT_DISCLOSURES_TAG = "VaultDisclosures";

export interface VaultDisclosuresQueryArgs {
    address: string;
}

export const vaultDisclosuresPublicApi = createApi({
    reducerPath: "abfVaultDisclosuresPublicApi",
    baseQuery: marketsPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    tagTypes: [VAULT_DISCLOSURES_TAG],
    endpoints: (builder) => ({
        vaultDisclosures: builder.query<VaultDisclosuresResponse, VaultDisclosuresQueryArgs>({
            providesTags: [VAULT_DISCLOSURES_TAG],
            query({ address }) {
                return {
                    url: `${ROUTE_GET_VAULT_DISCLOSURES}/${encodeURIComponent(address)}`,
                    method: "GET"
                };
            },
            transformResponse: (response: VaultDisclosuresResponseApi): VaultDisclosuresResponse =>
                parseVaultDisclosuresFromApi(response)
        })
    })
});

export const { useVaultDisclosuresQuery } = vaultDisclosuresPublicApi;

export function useVaultDisclosuresPublicApi() {
    const dispatch = useDispatch();

    return {
        resetVaultDisclosuresPublicApi: () =>
            dispatch(vaultDisclosuresPublicApi.util.invalidateTags([VAULT_DISCLOSURES_TAG]))
    };
}
